var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCatalogues = function SvgCatalogues(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    "data-name": "Layer 1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m460.019 463.054-30.4-288.81a44.126 44.126 0 0 0 -44.048-39.669h-.448l-29.683.289v-35.164a99.7 99.7 0 1 0 -199.4 0v37.11l-31.038.3a44.275 44.275 0 0 0 -43.643 39.773l-29.391 285.77a44.309 44.309 0 0 0 44.005 48.84l319.912.507h.078a44.308 44.308 0 0 0 44.056-48.946zm-271.982-363.354a67.7 67.7 0 1 1 135.4 0v35.476l-135.4 1.32zm237.063 376.234a11.408 11.408 0 0 1 -9.137 4.066h-.027l-319.912-.507a12.308 12.308 0 0 1 -12.224-13.566l29.388-285.769a12.151 12.151 0 0 1 12.123-11.048l30.726-.3v26.4a16 16 0 0 0 32 0v-26.71l135.4-1.32v28.029a16 16 0 1 0 32 0v-28.34l30-.293h.124a12.259 12.259 0 0 1 12.239 11.018l30.4 288.811a11.415 11.415 0 0 1 -3.1 9.529z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCatalogues, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/catalogues.a64fcb6e.svg";
export { ForwardRef as ReactComponent };